module.exports = __webpack_public_path__ + "static/media/lee_pcr_product_l.d8bf9422.svg";